// The notes on asking organisers, as one Markdown text to paste into an LLM: one section
// per account with a note, its handle, where asking stands and what the note says.

const STATUS = { OPEN: 'Offen', REQUESTED: 'Angefragt', APPROVED: 'Erlaubt', DENIED: 'Abgelehnt' };

const day = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? ''
    : date.toLocaleDateString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/** The accounts the export covers: those with a note, by handle. */
export const accountsWithNotes = (accounts) => (accounts || [])
  .filter((account) => account.handle && (account.note || '').trim())
  .sort((a, b) => a.handle.localeCompare(b.handle));

function section(account) {
  const steps = [
    account.requestedAt ? `angefragt ${day(account.requestedAt)}` : '',
    account.decidedAt ? `entschieden ${day(account.decidedAt)}` : '',
  ].filter(Boolean).join(', ');
  const lines = [
    `## @${account.handle}`,
    `- Instagram: https://www.instagram.com/${account.handle}/`,
    `- Stand: ${STATUS[account.status] || account.status}${steps ? ` (${steps})` : ''}`,
  ];
  if (account.hostActive) lines.push('- Host aktiv: ja (hat einen Host-Code eingelöst)');
  lines.push(`- Bilder: ${account.picturesCleared ?? 0} von ${account.pictures ?? 0} freigegeben`
    + ` · ${account.upcomingEvents ?? 0} kommende Events`);
  lines.push('- Notiz:');
  account.note.trim().split(/\r?\n/).forEach((line) => lines.push(`  > ${line}`));
  return lines.join('\n');
}

/** The Markdown text, or '' when no account has a note. */
export function notesMarkdown(accounts, now = new Date()) {
  const list = accountsWithNotes(accounts);
  if (list.length === 0) return '';
  return [
    '# Schick – Bildrechte: Notizen zu den Veranstaltern',
    `Stand ${day(now)} · ${list.length} Veranstalter mit Notiz. `
      + 'Jeder Abschnitt gehört zu einem Instagram-Account; „Stand“ sagt, wie weit die Anfrage ist, '
      + 'ob Schick die Bilder zeigen darf.',
    ...list.map(section),
  ].join('\n\n') + '\n';
}
